import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { App } from './App';
import { startAppUpdateChecks } from './lib/appUpdate';
import { listenForInstallPrompt } from './lib/install';
import { startIosWebApp, startNativeApp } from './lib/nativeApp';
import { installAudioUnlock } from './lib/sounds';
import { startUpdateChecks } from './lib/update';

listenForInstallPrompt();
installAudioUnlock();
startUpdateChecks();
startNativeApp();
startIosWebApp();
startAppUpdateChecks();

try {
  const theme = localStorage.getItem('theme');
  if (theme) document.documentElement.dataset.theme = theme;
} catch {
  /* storage unavailable */
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
